// extracted by mini-css-extract-plugin
export default {"zoomModal":"k5-z","image":"l5-z","button":"m5-z","isOverlayShown":"n5-z"};